// @flow
import $ from 'jquery';
import JQueryView, { on } from './JQueryView';
import YubinBango from 'yubinbango-core';

export default class SearchAddressForm extends JQueryView {
  $wrapper: any;

  yubinBango: Object;
  prefix: string;

  constructor(wrapper: string | Object, prefix?: string) {
    super(wrapper);
    this.$wrapper = $(wrapper);
    this.prefix = prefix ? prefix : '';
  }

  get $zipCodeField() {
    return this.$wrapper.find(`input[name*="${this.prefix}[zip_code]"]`);
  }

  get $errorField() {
    return this.$wrapper.find('.zip-code-errors');
  }

  get $prefectureField() {
    return this.$wrapper.find(`input[name*="${this.prefix}[prefecture]"]`);
  }

  get $cityField() {
    return this.$wrapper.find(`input[name*="${this.prefix}[city]"]`);
  }

  get $addressField() {
    return this.$wrapper.find(`input[name*="${this.prefix}[address]"]`);
  }

  addErrors = (errors: string) => {
    const zipCodeErrorElement = document.createElement('label');
    zipCodeErrorElement.textContent = errors;
    zipCodeErrorElement.classList.add('invalid-feedback');
    zipCodeErrorElement.classList.add('zip-code-errors');
    zipCodeErrorElement.classList.add('errors');

    if (
      this.$zipCodeField[0].parentElement.classList.contains('form-group-float')
    ) {
      this.$zipCodeField[0].parentElement.after(zipCodeErrorElement);
    } else {
      this.$zipCodeField.after(zipCodeErrorElement);
    }
    this.$zipCodeField.addClass('is-invalid');
  };

  setAddress = (addr: Object) => {
    if (!addr.region && !addr.locality && !addr.street) {
      this.addErrors('郵便番号が存在しません');
      return;
    }
    this.$prefectureField.val(addr.region);
    this.$prefectureField.addClass('form-control-active');
    this.$cityField.val(addr.locality);
    this.$cityField.addClass('form-control-active');
    this.$addressField.val(addr.street);
    this.$addressField.addClass('form-control-active');
  };

  // 「住所を検索する」ボタンを用意してある場合
  @on({ event: 'click', selector: '.search-address-button' })
  // 郵便番号入力時に自動で住所を入力する場合
  @on({ event: 'focusout', selector: '.autofill-zip-code-field' })
  onChangeZipCode() {
    this.$errorField.addClass('d-none');
    const zipCode = this.$zipCodeField.val();

    $.get(`${new YubinBango.Core().URL}/${zipCode.slice(0, 3)}.js`)
      .done(() => {
        this.yubinBango = new YubinBango.Core(zipCode, addr =>
          this.setAddress(addr),
        );
      })
      .fail(() => {
        this.addErrors('郵便番号が存在しません');
      });
  }
}
